import { sanitizeIncomingText, sanitizeOutgoingText } from "./sanitize.js"

export default class SearchParams {
  constructor() {
    const _hash = window.location.hash
    this._params = new URLSearchParams(_hash.slice(1))
  }

  get attributes() {
    const attributes = this._params.get("attributes")
    if (!attributes) return
    return attributes
  }

  get text() {
    return sanitizeIncomingText(this._params.get("text"))
  }

  get mode() {
    return this._params.get("mode")
  }

  get params() {
    return this._params
  }

  get url() {
    const location = window.location
    return `${location.origin}${location.pathname}#?${searchParams.params}`
  }

  set attributes(value) {
    this._params.set("attributes", value)
  }

  set text(value) {
    this._params.set("text", sanitizeOutgoingText(value))
  }

  set mode(value) {
    this._params.set("mode", value)
  }
}
